import { render, staticRenderFns } from "./Dissertaciya.vue?vue&type=template&id=090481a4&lang=pug&"
import script from "./Dissertaciya.vue?vue&type=script&lang=ts&"
export * from "./Dissertaciya.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports